// Internal modules
import { $logger, ONBOARD_OPTION_CHANGED_PAYLOAD } from '@/lib';
import { changeHandler as genericChangeHandler } from '../Form/handlers';
import { logBlurOrFocusEvent } from '../Form/utils';
import { uncheckPreviousTermBox } from './utils';

const blurHandler = logBlurOrFocusEvent;
const focusHandler = logBlurOrFocusEvent;

const changeHandler = (...args) => {
  const [, option] = args;

  // unchecking terms box before switching to the other onboard option
  uncheckPreviousTermBox(option);

  $logger.fpti(
    'onboard_option_changed',
    ONBOARD_OPTION_CHANGED_PAYLOAD(option),
  );

  genericChangeHandler(...args);
};

export { blurHandler, changeHandler, focusHandler };
